import { stateTypes, mutationTypes } from './specification.moduletypes';
import { UnitsWithSpecifications } from '../models/specification.models';

const mutations = {
  [mutationTypes.saveSpecification](state, data) {
    let { specification, units } = data;
    units.forEach(function(key) {
      let unit = state[stateTypes.units].find(e => e.unitName === key);
      unit.specifications.push(specification);
    });
  },
  [mutationTypes.addSpecificationSelections](state, data) {
    state[stateTypes.specificationSelections] = data;
  },
  [mutationTypes.setAllUnitsWithSpecifications](state, data) {
    if (data.units) {
      state[stateTypes.unitsWithSpecification] = data.units.map(unit => {
        return new UnitsWithSpecifications(unit);
      });
    }
  },
  [mutationTypes.deleteSpecification](state, specGuid) {
    let units = state[stateTypes.unitsWithSpecification];

    units.forEach(unit => {
      // first check if there deleted spec is in unassignedSpecifications
      if (Array.isArray(unit.unassignedSpecifications)) {
        unit.unassignedSpecifications.forEach((specification, index, specs) => {
          if (specification.specGuid == specGuid) {
            specs.splice(index, 1);
          }
        });
      }
      // then if there is some assigned to machine group
      if (Array.isArray(unit.unitMachineGroups)) {
        unit.unitMachineGroups.forEach((group, index, groups) => {
          if (group.machineGroupSpecification !== null && group.machineGroupSpecification.specGuid == specGuid) {
            groups[index].machineGroupSpecification = null;
          }
        });
      }
    });
  },
  [mutationTypes.setSingleSpecification](state, specification) {
    state[stateTypes.currentlyEditedSpecification] = specification;
  }
};

export default mutations;
